<mat-expansion-panel class="card-panel" [expanded]="true" hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{('dashboard.' + name) | translate}}
    </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="panel-content">
    @if (data) {
      <div>
        @if (type === 'reward') {
          <div class="pie-double-info">
            <mat-list role="list">
              @for (item of data; track item; let i = $index) {
                <mat-list-item role="listitem">
                  <div mat-list-icon>
                    <div style="width: 40px">
                      @if (i === 0) {
                        <img src="../../../../../assets/images/first.png"/>
                      }
                    </div>
                    <div style="width: 35px">
                      @if (i === 1) {
                        <img src="../../../../../assets/images/second.png"/>
                      }
                    </div>
                    <div style="width: 30px">
                      @if (i === 2) {
                        <img src="../../../../../assets/images/third.png"/>
                      }
                    </div>
                  </div>
                  <h4 mat-line>{{item.name}} - <b>{{item.count}} Credits</b></h4>
                  <p mat-line>{{item.targetGroup}}</p>
                </mat-list-item>
              }
            </mat-list>
            @if (!data.length) {
              <p class="no-data-msg-chart">No Data</p>
            }
          </div>
        }
        @if (type === 'status') {
          <div class="pie-double-info">
            <mat-list role="list">
              @for (item of data; track item; let i = $index) {
                <mat-list-item role="listitem">
                  <div mat-list-icon>
                    <div style="width: 40px">
                      <img style="filter: invert(0.8);" src="{{item.icon}}"/>
                    </div>
                  </div>
                  <h4 mat-line>{{item.name}}</h4>
                  <p mat-line>{{item.frontUser.firstName}} {{item.frontUser.lastName}}</p>
                  <p mat-line>{{item.time | date}}</p>
                </mat-list-item>
              }
            </mat-list>
            @if (!data.length) {
              <p class="no-data-msg-chart">No Data</p>
            }
          </div>
        }
      </div>
    }

  </div>
</mat-expansion-panel>




